import Toggle from '@atlaskit/toggle';
import Tooltip from '@atlaskit/tooltip';
import { ANALYTICS_ACTION_TOGGLED, ANALYTICS_SUBJECT_RADIO, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { updateCloudMigrationOptIn } from '@atlassian/mpac-api-client';
import { log } from '@atlassian/mpac-utils';
import React, { useState } from 'react';
import { MANAGE_PARTNER_APPS_VIEW, TOGGLE_CLOUD_MIGRATION_TRIAL } from '../../../../analytics/Events';
const CloudMigrationTrial = _ref => {
  let {
    appKey,
    mpacBaseUrl,
    appCloudMigrationData
  } = _ref;
  const [cloudMigrationTrialOpted, setCloudMigrationTrialOpted] = useState(appCloudMigrationData.cloudMigrationTrialOptIn);
  const fireAnalyticsEvent = useAnalyticsEvents();
  const onChangeCloudMigrationTrial = () => {
    setCloudMigrationTrialOpted(cloudMigrationTrialOptedValue => !cloudMigrationTrialOptedValue);
    setCloudMigrationTrial(!cloudMigrationTrialOpted);
    handleAnalyticsEvent(!cloudMigrationTrialOpted);
  };
  const handleAnalyticsEvent = cloudMigrationTrialOptedEvent => fireAnalyticsEvent({
    eventContainer: MANAGE_PARTNER_APPS_VIEW,
    actionSubject: ANALYTICS_SUBJECT_RADIO,
    action: ANALYTICS_ACTION_TOGGLED,
    actionSubjectId: TOGGLE_CLOUD_MIGRATION_TRIAL,
    attributes: {
      appKey,
      cloudMigrationTrialOptedEvent
    }
  });
  const setCloudMigrationTrial = async cloudMigrationTrialBoolean => {
    try {
      const updateRequestBody = {
        appKey,
        cloudMigrationTrialOptIn: cloudMigrationTrialBoolean
      };
      await updateCloudMigrationOptIn(mpacBaseUrl, updateRequestBody);
    } catch (error) {
      log.error('CloudMigrationTrialToggle', 'Failed to update cloud migration trial state', {
        error
      });
    }
  };
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: cloudMigrationTrialOpted ? 'Disable cloud migration trial' : 'Enable cloud migration trial'
  }, /*#__PURE__*/React.createElement(Toggle, {
    onChange: onChangeCloudMigrationTrial,
    defaultChecked: cloudMigrationTrialOpted,
    isChecked: cloudMigrationTrialOpted,
    label: "Cloud migration trial Toggle"
  }));
};
export default CloudMigrationTrial;